export function flattenEmployeeData(data) {
  return data.map((emp) => {
    return {
      "Employee Name": emp.employee_name,
      "Father Name": emp.father_name,
      "Phone Number": emp.phone_number,
      "Bank Account": emp.bank_account,
      "IFSC Code": emp.ifsc_code,
      Designation: emp.designation,
      "Address - Post": emp.address.post,
      "Address - District": emp.address.district,
      "Address - State": emp.address.state,
      "Address - Pin Code": emp.address.pin_code,
      "Date of Birth": emp.personal_details.date_of_birth,
      Gender: emp.personal_details.gender,
      Nationality: emp.personal_details.nationality,
      "Marital Status": emp.personal_details.marital_status,
      Religion: emp.personal_details.religion,
      "Aadhaar Number": emp.identification_numbers.aadhaar_number,
      "PAN Number": emp.identification_numbers.pan_number,
      "UAN Number": emp.identification_numbers.uan_number,
      "Personal E-mail": emp.contact_information.email,
      Grade: emp.employment_details.grade,
      Location: emp.employment_details.location,
      "Business Unit": emp.employment_details.business_unit,
      Division: emp.employment_details.division,
      "Date of Joining": emp.employment_details.date_of_joining,
      "Date of Appointment": emp.employment_details.date_of_offer,
      "CTC Annual": emp.employment_details.ctc_annual,
      "Basic Pay (Monthly)": emp.salary.basic_pay.monthly,
      "Basic Pay (Annually)": emp.salary.basic_pay.annually,
      "House Rent (Monthly)": emp.salary.house_rent.monthly,
      "House Rent (Annually)": emp.salary.house_rent.annually,
      "Special Allowance (Monthly)": emp.salary.special_allowance.monthly,
      "Special Allowance (Annually)": emp.salary.special_allowance.annually,
      "Performance Allowance (Monthly)":
        emp.salary_components.performance_allowance.monthly,
      "Performance Allowance (Annually)":
        emp.salary_components.performance_allowance.annually,
      "Bonus/Exgratia (Monthly)": emp.salary_components.bonus_exgratia.monthly,
      "Bonus/Exgratia (Annually)":
        emp.salary_components.bonus_exgratia.annually,
      "PF Employer Contribution (Monthly)":
        emp.salary_components.pf_employer_contribution.monthly,
      "PF Employer Contribution (Annually)":
        emp.salary_components.pf_employer_contribution.annually,
      "Variable Pay (Monthly)": emp.salary_components.variable_pay.monthly,
      "Variable Pay (Annually)": emp.salary_components.variable_pay.annually,
      "Bank Name": emp.bank_details.bank_name,
      "Account Opening Date": emp.bank_details.account_opening_date,
      "Languages Known": emp.languages_known.join(", "),
      "Mother Name (Family Details)": emp.personal_details.mother_name,
      "PF/Gratuity Nominee": emp.nominee_for_gratuity[0]?.name || "",
      "Nominee Relationship": emp.nominee_for_gratuity[0]?.relationship || "",
      "Nominee Age": emp.form_f_details.nominee_details[0]?.age || "",
      "Nominee DOB": "", // Not provided
      "Nominee Share Percentage":
        emp.nominee_for_gratuity[0]?.share_percentage?.replace("%", "") || "",
      "Emergency Contact Name": "", // Not provided
      "Emergency Contact Mobile": "", // Not provided
      "Emergency Contact Email": emp.contact_information.email,
      "Blood Group": "", // Not available
      "Reporting Manager": "", // Not available
      "Probation Period": "", // Not available
      "Retirement Age": "", // Not available
      "Source of Candidate": "", // Not available
    };
  });
}
function sortObjectByLetterKeys(obj) {
  const entries = Object.entries(obj);

  // Separate entries into those starting with a letter vs others
  const letterEntries = entries.filter(([key]) => /^[a-zA-Z]/.test(key));
  const otherEntries = entries.filter(([key]) => !/^[a-zA-Z]/.test(key));

  // Sort both groups alphabetically
  letterEntries.sort(([a], [b]) => a.localeCompare(b));
  otherEntries.sort(([a], [b]) => a.localeCompare(b));

  // Merge back with letter-keys first
  return Object.fromEntries([...letterEntries, ...otherEntries]);
}
// Helper function: Capitalize first letter of every word
function toTitleCase(str) {
  if (!str) return "";
  return str
    .toString()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

// Helper function: Format date as dd-mmm-yyyy
function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return dateString; // if invalid, return as is
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const calculateYearsOfService = (dateOfJoining) => {
  if (!dateOfJoining) return 0;
  const joiningDate = new Date(dateOfJoining);
  const currentDate = new Date();
  const diffInMs = currentDate - joiningDate;
  const diffInYears = diffInMs / (1000 * 60 * 60 * 24 * 365.25);
  return Math.floor(diffInYears * 10) / 10; // Round to 1 decimal place
};
const calculateTotalExperience = (employee) => {
const previousOrgExp = parseFloat(employee.employment_details?.total_experience) || 0;
const currentOrgExp = calculateYearsOfService(employee.employment_details?.date_of_joining);
const totalExp = previousOrgExp + currentOrgExp; 
const roundedExp = Math.round(totalExp);
return roundedExp;
};

export function flattenEmployeeDataT(data) {
  return data.map((emp) => {
    const obj = {
      "First Name": toTitleCase(emp.firstName),
      "Middle Name": toTitleCase(emp.middleName),
      "Last Name": toTitleCase(emp.lastName),
      "Employee Name": toTitleCase(emp.personal_information.employee_name),
      "Father Name": toTitleCase(emp.personal_information.father_name),
      "Mother Name (Family Details)": toTitleCase(emp.personal_information.mother_name),
      "Date of Birth": formatDate(emp.personal_information.date_of_birth),
      Age:
        new Date().getFullYear() -
        parseInt(emp.personal_information.date_of_birth.split("-")[0]),
      Gender: toTitleCase(emp.personal_information.gender),
      Nationality: toTitleCase(emp.personal_information.nationality),
      "Marital Status": toTitleCase(emp.personal_information.marital_status),
      Religion: toTitleCase(emp.personal_information.religion),
      "Blood Group": emp.personal_information.blood_group?.toUpperCase(),
      "Languages Known": emp.personal_information.languages_known
        .map(toTitleCase)
        .join(", "),

      "Address - Village": toTitleCase(emp.address_information.permanent_address.village),
      "Address - Post": toTitleCase(emp.address_information.permanent_address.post),
      "Address - District": toTitleCase(emp.address_information.permanent_address.district),
      "Address - State": toTitleCase(emp.address_information.permanent_address.state),
      "Address - Pin Code": emp.address_information.permanent_address.pin_code,

      "Phone Number": emp.contact_information.phone_number,
      "Personal E-mail": emp.contact_information.email?.toLowerCase(),
      "Emergency Contact Name": toTitleCase(emp.contact_information.emergency_contact?.name),
      "Emergency Contact Mobile": emp.contact_information.emergency_contact?.mobile,
      "Emergency Contact Email": emp.contact_information.emergency_contact?.email?.toLowerCase(),
      
      "Aadhaar": emp.identification_documents.aadhaar_number,
      "PAN": emp.identification_documents.pan_number?.toUpperCase(),
      
      Designation: toTitleCase(emp.employment_details.designation),
      Grade: emp.employment_details.grade,
      "UAN": emp.employment_details.uan_number,
      Location: toTitleCase(emp.employment_details.location),
      "Business Unit": toTitleCase(emp.employment_details.business_unit),
      Division: toTitleCase(emp.employment_details.division),
      "Date of Joining": formatDate(emp.employment_details.date_of_joining),
      "Date of Offer": formatDate(emp.employment_details.date_of_appointment),
      "Probation Period": emp.employment_details.probation_period_in_months,
      "Retirement Age": emp.employment_details.retirement_age,
      "Source of Hiring": toTitleCase(emp.employment_details.source_of_candidate),
      "Reporting Manager": toTitleCase(emp.employment_details.reporting_manager),
      "Department": toTitleCase(emp.employment_details.department),
      "Last Organization": toTitleCase(emp.employment_details.last_organisation),
      "Last Promotion Date": formatDate(emp.employment_details.last_promotion_date),
      "Official E-mail": emp.employment_details.official_email?.toLowerCase(),
      "Reporting Manager Employee ID": emp.employment_details.reporting_manager_employee_id,
      "Reporting Manager Designation": emp.employment_details.reporting_manager_designation,
      "Total Experience": calculateTotalExperience(emp),

      "CTC Annual": Object.values(emp.salary_and_compensation)[Object.keys(emp.salary_and_compensation).length - 1]?.ctc,

      "Bank Name": toTitleCase(emp.bank_details.bank_name),
      "Bank Account Number": emp.bank_details.account_number,
      "IFSC": emp.bank_details.ifsc_code?.toUpperCase(),

      "PF/Gratuity Nominee": toTitleCase(emp.nominee_information[0]?.nominee_name || ""),
      "Nominee Relationship": toTitleCase(emp.nominee_information[0]?.relationship || ""),
      "Nominee Age": emp.nominee_information[0]?.nominee_age || "",
      "Nominee Date Of Birth": formatDate(emp.nominee_information[0]?.nominee_dob || ""),
      "Nominee Share Percentage": emp.nominee_information[0]?.share_percentage || "",

      "Physical Disabilities": toTitleCase(emp.declarations_and_compliance.physical_disabilities),
      "Major Illness": toTitleCase(emp.declarations_and_compliance.major_illness),
      "Court Case(s)": toTitleCase(emp.declarations_and_compliance.court_cases),
      "Police Custody": toTitleCase(emp.declarations_and_compliance.police_custody),
      // "Declaration Location": toTitleCase(emp.declarations_and_compliance.declaration_location),
      "Other Qualification": toTitleCase(emp.education.other.map((item) => item.degree).join(" | ")),
      // "Driving License Number (DL no.)": "",
      "Verified": emp.isVerified ? "✅ Yes" : "❌ Not Verified",
    };

    let salaryObj = {}
    Object.entries(emp.salary_and_compensation).forEach(([key, value]) => {
      salaryObj[toTitleCase(key)+" CTC"] = value.ctc=="nan" ? "N/A" : value?.ctc;
      salaryObj[toTitleCase(key)+" Basic"] = value.basic=="nan" ? "N/A" : value?.basic;
      salaryObj[toTitleCase(key)+" Gross"] = value.gross=="nan" ? "N/A" : value?.gross;
      salaryObj[toTitleCase(key)+" Incentive"] = value.incentive=="nan" ? "N/A" : value?.incentive;
    });

    let educationObj = {}
    Object.entries(emp.education).forEach(([key, value]) => {
      if (key=="other") return;
      educationObj[toTitleCase(key)] = value.education_source;
    });



    return {
      "Employee ID": emp.employment_details.eid || emp.eid,
      "First Name": toTitleCase(emp.firstName),
      "Middle Name": toTitleCase(emp.middleName),
      "Last Name": toTitleCase(emp.lastName),
      ...sortObjectByLetterKeys(obj),
      ...educationObj,
      ...salaryObj,
    };
  });
}


export const xlsxExport = (filename, XLSX) => {
  const htmlTable = document.getElementById("export");

  if (htmlTable) {
    const ws = XLSX.utils.table_to_sheet(htmlTable);

    // Loop through each cell to apply the centering style
    for (const cell in ws) {
      if (ws.hasOwnProperty(cell)) {
        // Skip header cells (e.g., A1, B1, etc.)
        if (cell.match(/[A-Z]+1$/)) {
          continue;
        }

        const cellRef = XLSX.utils.decode_cell(cell);
        const cellStyle =
          ws[cellRef.r] && ws[cellRef.r][cellRef.c]
            ? Object.assign({}, ws[cellRef.r][cellRef.c], {
                alignment: { horizontal: "center", vertical: "center" },
              })
            : { alignment: { horizontal: "center", vertical: "center" } };

        ws[cellRef.r] = ws[cellRef.r] || [];
        ws[cellRef.r][cellRef.c] = cellStyle;
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate the Excel file
    const excelBlob = new Blob(
      [s2ab(XLSX.write(wb, { bookType: "xlsx", type: "binary" }))],
      {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

    // Create a downloadable link
    const url = URL.createObjectURL(excelBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.xlsx`;
    link.click();

    // Clean up the object URL
    URL.revokeObjectURL(url);
  }
};

// Convert string to ArrayBuffer
const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};
